import { FC } from 'react';
import { Typography } from './Typography';
import { MonitorErrorIcon } from '@/assets';
import { Alert, AlertDescription, Button } from '../shadcn';
import { useTranslation } from 'react-i18next';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';

interface ErrorFallbackProps {
  onRetry: VoidFunction;
  onNavigateToCatalog: VoidFunction;
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({ onRetry, onNavigateToCatalog }) => {
  const { t } = useTranslation();
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  if (isMinimalistic)
    return (
      <div className='flex min-h-full flex-1 flex-col items-center justify-center gap-5 p-4 text-center'>
        <MonitorErrorIcon />

        <div className='flex w-[300px] flex-col items-center gap-2'>
          <Typography variant='h3' className='text-[20px] font-medium'>
            {t('errors.somethingWentWrong')}
          </Typography>

          <Typography variant='text2' color='mutedForeground'>
            {t('errors.pleaseTryAgain')}
          </Typography>
        </div>

        <div className='flex w-[250px] flex-col gap-2'>
          <Button variant='secondary' onClick={onNavigateToCatalog} className='h-12 w-full'>
            {t('actions.toCatalog')}
          </Button>

          <Button onClick={onRetry} className='h-12 w-full'>
            {t('errors.reloadPage')}
          </Button>
        </div>
      </div>
    );

  return (
    <div className='p-4 flex flex-col items-center justify-center min-h-full'>
      <Alert variant='destructive' className='flex justify-center max-w-120 mb-4'>
        <AlertDescription className='text-center'>{t('errors.generic')}</AlertDescription>
      </Alert>

      <div className='flex gap-2'>
        <Button variant='secondary' onClick={onNavigateToCatalog}>
          {t('actions.toCatalog')}
        </Button>

        <Button onClick={onRetry}>{t('errors.reloadPage')}</Button>
      </div>
    </div>
  );
};
